import { isDefined } from '@sgme/fp';
import classNames from 'classnames';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage, FormattedNumber } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { FixedUnitWithPreValueValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

export interface ProductSummaryFixedUnitWithPreValueFieldProps {
  node: FixedUnitWithPreValueValueDefinition;
}

export const ProductSummaryFixedUnitWithPreValueField: FC<ProductSummaryFixedUnitWithPreValueFieldProps> = ({
  node,
}) => {
  const data = useReadonlyField().getMetadataWithData(node);
  const translationKey = node.translationKey ?? node.id;
  const isHighlighted = node.isHighlighted ?? false;

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p
        className={classNames('text-large m-0', {
          'fw-light': !isHighlighted,
          'fw-bold': isHighlighted,
          'text-danger': isHighlighted,
        })}
        data-e2e={`product-summary-field-${node.id}`}
      >
        {isDefined(data?.preValue) && (
          <FormattedMessage id={`field.${data.preValue}` as IntlKey} defaultMessage={`(${data.preValue}) `} />
        )}{' '}
        {isDefined(data?.value) && <FormattedNumber maximumFractionDigits={4} value={data.value} />}
        {isDefined(node.unit) && (
          <FormattedMessage id={`form.${node.unit}` as IntlKey} defaultMessage={`${node.unit}`} />
        )}
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryFixedUnitWithPreValueField.displayName = 'ProductSummaryFixedUnitWithPreValueField';
